import React, { ReactElement } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';

const SpinnerContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 300px) !important;
`;

const Spinner = (): ReactElement => {
    const fetching = useSelector((state: RootState) => state.systemReducer.isFetching);
    return fetching ? (
        <SpinnerContainer>
            <CircularProgress size={200} color={'secondary'} />
        </SpinnerContainer>
    ) : (
        <div />
    );
};

export default Spinner;
